// many packages or libraries end up using CountryCode as a type for inputs
// and rather than trying to import the right one from each package
// we'll define the ones that we support at Square here and import them as needed
export enum CountryCode {
  US = 'US',
  CA = 'CA',
  GB = 'GB',
  AU = 'AU',
  FR = 'FR',
  ES = 'ES',
  IE = 'IE',
  JP = 'JP',
}

export enum LanguageCode {
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  JA = 'ja',
  CA = 'ca',
}

export type Locale =
  | 'ca-ES'
  | 'en-AU'
  | 'en-CA'
  | 'en-GB'
  | 'en-IE'
  | 'en-US'
  | 'es-ES'
  | 'es-US'
  | 'fr-CA'
  | 'fr-FR'
  | 'ja-JP';
